import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "regles-widget-group"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "site-widget"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 3,
  class: "graphs-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderWidget = _resolveComponent("HeaderWidget")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_NoData = _resolveComponent("NoData")!
  const _component_PieChart = _resolveComponent("PieChart")!
  const _component_BarGraph = _resolveComponent("BarGraph")!
  const _component_ElevatedCard = _resolveComponent("ElevatedCard")!

  return (_openBlock(), _createBlock(_component_ElevatedCard, { widthType: 'twoThirds' }, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderWidget, {
        iconUrl: _ctx.loadIcon,
        title: _ctx.widgetTitle,
        onClick: _ctx.onPressHeader
      }, null, 8, ["iconUrl", "title", "onClick"]),
      (_ctx.widget)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_ReglePastille, { cle: "dashboard.widgetPerimetreCommun" }),
            _createVNode(_component_ReglePastille, { cle: "dashboard.widgetPreventifFenetres" })
          ]))
        : _createCommentVNode("", true),
      (_ctx.widget)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.widget.sites == null || _ctx.widget.sites.length > 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('multisites')), 1))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.widget.sites, (site) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: site.id,
                    class: "site-widget"
                  }, [
                    _createTextVNode(_toDisplayString(site.description) + " ", 1),
                    (site.id !== _ctx.widget.sites[_ctx.widget.sites.length - 1].id)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, ", "))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isWidgetLoading && _ctx.isPreventiveCircleNoData && _ctx.isPreventiveChartNoData)
        ? (_openBlock(), _createBlock(_component_NoData, {
            key: 2,
            textNoData: "widget.preventive.noData"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            ((!_ctx.isPreventiveCircleNoData || _ctx.isCircleLoading) && _ctx.isEnded)
              ? (_openBlock(), _createBlock(_component_PieChart, {
                  key: 0,
                  colors: [_ctx.getColorEnCours(), _ctx.getColorARealiser(), _ctx.getColorRealiser()],
                  height: '95%',
                  isLoading: _ctx.isCircleLoading || !_ctx.isEnded,
                  labels: [
                    _ctx.$t('widgetPreventive.inProgress') + ' (' + _ctx.getPreventiveCircleData.inProgressTotal + ')',
                    _ctx.$t('widgetPreventive.toDo') + ' (' + _ctx.getPreventiveCircleData.awaitingRealizationTotal + ')',
                    _ctx.$t('widgetPreventive.done') + ' (' + _ctx.getPreventiveCircleData.achievedTotal + ')',
                ],
                  seriesValues: _ctx.donutSeries,
                  showDataLabels: true,
                  showLegend: true,
                  title: _ctx.titlePie,
                  width: '350px',
                  class: "pie-chart-container chart-width",
                  position: "right",
                  onDataPointClicked: _ctx.naviguerVersRecherchePie
                }, null, 8, ["colors", "isLoading", "labels", "seriesValues", "title", "onDataPointClicked"]))
              : _createCommentVNode("", true),
            _createVNode(_component_BarGraph, {
              categories: _ctx.getMonths(),
              colors: [_ctx.getColorEnCours(), _ctx.getColorARealiser(), _ctx.getColorRealiser()],
              equipementInterventionNonPreventiveTooltip: _ctx.equipementInterventionNonPreventiveTooltip,
              loading: _ctx.isChartLoading || _ctx.isCircleLoading,
              seriesData: _ctx.barSeries,
              showLegend: false,
              class: "bar-graph-container chart-width2",
              onDataPointClicked: _ctx.naviguerVersRechercheBar
            }, null, 8, ["categories", "colors", "equipementInterventionNonPreventiveTooltip", "loading", "seriesData", "onDataPointClicked"])
          ]))
    ]),
    _: 1
  }))
}